function getArchivedProjectsTabs(fundedCount: number, finishedCount: number) {
  return [
    {
      label: 'Prebiehajúce príležitosti',
      count: {
        value: fundedCount,
        color: '#fff',
        bgColor: '#000',
      },
    },
    {
      label: 'Vyplatené príležitosti',
      count: { value: finishedCount, color: '#fff', bgColor: '#000' },
    },
  ]
}

export { getArchivedProjectsTabs }
